import * as Dtos from '../../dtos/Tmd.dtos';
import { IFieldState, IRegistrationFormState } from "./index";

export const initialInstitutionItemCategoryState: Dtos.InstitutionItemCategory & IRegistrationFormState = {
    institutionItemTemplateCategoryId: null,
    institutionItemTemplateCategory: null,
    institutionItems: [],
    institutionItemSummaries: [],
    saveAndReturn: null
}

export interface IInstitutionItemCategoryReduxFormState {
    categoryId: IFieldState<number>,
    category: IFieldState<Dtos.Category>,
    institutionItems: IFieldState<Dtos.InstitutionItem[]>,
    InstitutionItemSummaries: IFieldState<Dtos.InstitutionItemSummary[]>
}
